function formatErrorValue(value) {
  if (value === undefined || value === null) {
    return null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    const parts = value.map((item) => formatErrorValue(item)).filter(Boolean);
    return parts.length ? parts.join(', ') : null;
  }

  if (typeof value === 'object') {
    const nested =
      formatErrorValue(value.error_user_msg)
      ?? formatErrorValue(value.error?.error_user_msg)
      ?? formatErrorValue(value.error?.message)
      ?? formatErrorValue(value.error)
      ?? formatErrorValue(value.message)
      ?? formatErrorValue(value.errors)
      ?? formatErrorValue(value.response?.errors)
      ?? formatErrorValue(value.response?.error)
      ?? formatErrorValue(value.response?.message);

    if (nested) {
      return nested;
    }

    const entries = Object.entries(value)
      .map(([key, entryValue]) => {
        const formatted = formatErrorValue(entryValue);
        return formatted ? `${key}: ${formatted}` : null;
      })
      .filter(Boolean);

    if (entries.length) {
      return entries.join('; ');
    }
  }

  return null;
}

function extractGeneralErrorMessage(generalError) {
  return formatErrorValue(generalError);
}

/**
 * Extract a user-facing error message from a template API response or axios error.
 */
export function parseApiError(errorOrResponse, fallback = 'Request failed') {
  const axiosData = errorOrResponse?.response?.data;
  const serviceData = errorOrResponse?.data;
  const candidates = [
    axiosData?.data,
    serviceData?.data,
    axiosData,
    serviceData,
    typeof errorOrResponse === 'string' ? errorOrResponse : null,
  ].filter(Boolean);

  for (const data of candidates) {
    if (typeof data === 'string') {
      const trimmed = data.trim();
      if (trimmed) {
        return trimmed;
      }
    }

    const fromGeneralError = extractGeneralErrorMessage(data?.general_error);
    if (fromGeneralError) {
      return fromGeneralError;
    }

    const fromData = formatErrorValue(data);
    if (fromData) {
      return fromData;
    }
  }

  const fromRoot = formatErrorValue(errorOrResponse?.message);
  if (fromRoot) {
    return fromRoot;
  }

  return fallback;
}
